// removed by extract-text-webpack-plugin
module.exports = {"office-hour":"OfficeHours__office-hour___d9A-J","scheduling-deadline":"OfficeHours__scheduling-deadline___3mu6w","scheduling-heading":"OfficeHours__scheduling-heading___15Nw3"};